import { reactive } from "@vue/composition-api";

export default reactive({
  header: "",
  title: "",
  sharedUrl: "",
  isSharedSearch: false
});
